const emailAppHash = (baseUrl) => {
  const url = [ baseUrl, "email_app_hash" ].join("/");
  return {
    concept1: {
      learn: `${url}/concept1/learn.png`
    },
    concept2: {
      nSwitch: `${url}/concept2/n_switch.png`,
      phone: `${url}/concept2/phone.png`,
      dollarIcon: `${url}/concept2/dollar.png`,
      displayIcon: `${url}/concept2/display.png`,
      careIcon: `${url}/concept2/care.png`
    }
  };
};

export default emailAppHash;
